import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';

import DataService from 'lib/DataService';

import BuildingInfo from './BuildingInfo';
import Brochures from './Brochures';
import Loading from 'components/Loading';
import Modal from 'components/Modal';
import { GhostButton, BigBlueButton } from 'lib/styles';
import BuildingImages from './BuildingInfo/BuildingImages';
import CloneBrochure from './CloneBrochure';

import BuildingsContext from 'contexts/Buildings';
import UserContext from 'contexts/User';

const Api = new DataService();

// TODO: custom prompt and confirm?

class Building extends Component {
	state = {
	  loading: true, // Loading brochures
	  brochures: [],
	  sort: 'date',
	  viewImages: false,
	  loadingClone: false,
	  canCloneBrochure: true,
	  cloneBrochure: false,
	  createClone: false,
	}

	viewImagesToggleHandler = () => this.setState({ viewImages: !this.state.viewImages })

	createBrochureHandler = async building => {
	  const { t } = this.props;
	  const name = window.prompt(t('building/prompt/Brochure name'), building.address);

	  if (name !== '' && name !== null) {
	    return await Api.addBrochure({ name, building: building.slug })
	      .then(response => {
	        this.setState(state => {
	          const brochures = [ ...state.brochures ];

	          brochures.push({
	            ...response.result.brochure,
	            new: true,
	          });

	          return {
	            brochures
	          };
	        });
	      });
	  }
	}

	setCanCloneBrochure(canCloneBrochure) {
		this.setState({ canCloneBrochure });
	}

	addBrochureClone = (brochure, spaces, space) => {
	  this.setState((state, props) => {
			const brochures = [ ...state.brochures ];

			if (brochure.type === 'default' && space) {
				const building = { ...props.buildings.find(building => props.match.params.buildingId === building.slug) };
				building.spaces = Array.from(building.spaces);

				building.spaces.forEach((item, i) => {
					if (item.slug === space) {
						const data = { ...item };
						data.default_brochure = brochure.id;
						data.default_brochure_pdf = brochure.pdf;
						building.spaces[i] = data;
					}
				});
				props.updateBuildingHandler(building);
			}

	    brochures.push({
	      ...brochure,
	      new: true,
			});

	    return {
	      brochures,
	      createClone: false,
	      cloneBrochure: false,
	      loadingClone: false,
	    };
	  });
	}

	cloneBrochureHandler = async brochureId => {
	  return await Api.getBrochure(brochureId)
	    .then(response => {
	      if (this.mounted) {
	        const brochure = response.result.brochure[0];

	        this.setState({
	          cloneBrochure: brochure,
	          loadingClone: true,
	        });
	      }
	    });
	}

	deleteBrochureHandler = id => {
	  Api.deleteBrochure(id)
	    .then(response => {
	      this.setState((state, props) => {
	        const brochures = [ ...state.brochures ];
					const deletedIndex = brochures.findIndex(brochure => brochure.id === id);

					const brochure = state.brochures[deletedIndex];
					if (brochure && brochure.type === 'default') {
						const building = { ...props.buildings.find(building => props.match.params.buildingId === building.slug) };
						building.spaces = Array.from(building.spaces);

						building.spaces.forEach((space, i) => {
							console.log(space);
							if (space.default_brochure === id) {
								console.log('default found', space);
								const data = { ...space };
								data.default_brochure = false;
								data.default_brochure_pdf = null;
								building.spaces[i] = data;
							}
						});
						props.updateBuildingHandler(building);
					}

	        brochures.splice(deletedIndex, 1);

	        return { brochures };
	      });
	    })
	}

	componentDidMount() {
	  this.mounted = true;

	  const {
	    match: {
	      params: {
	        buildingId
	      }
	    }
	  } = this.props;

	  Api.getBuilding(buildingId)
	    .then(building => {

	      building.fullData = true;
	      //delete building.spaces;

	      this.props.updateBuildingHandler(building);
	    });

	  Api.getBrochures(buildingId)
	    .then(response => {
	      if (this.mounted) {
	        const { brochures } = response.result;

	        this.setState({ brochures, loading: false });
	      }
	    });
	}

	componentWillUnmount() {
	  this.mounted = false;
	}

	render() {
		const {
			t,
			lng,
			match: {
				params: {
					buildingId
				}
			}
		} = this.props;

		const currentBuilding = this.props.buildings.find(building => buildingId === building.slug);
		const allowedBrochureSpaces = currentBuilding.spaces.filter(space => !space.default_brochure);

		return (
			<UserContext.Consumer>
				{ user => (
					<BuildingsContext.Consumer>
						{ buildings => {

							const building = buildings.find(({ slug }) => slug === buildingId);

							if (typeof building === 'undefined') {
								return <Redirect to={`/${lng}/t/`} />;
							}

							if (!building.fullData) {
								return <Loading />;
							}

							return (
								<React.Fragment>
									<BuildingInfo
										building={building}
										viewImagesToggleHandler={this.viewImagesToggleHandler}
									/>

									<Brochures
										loading={this.state.loading}
										building={building}
										updateBuildingHandler={this.props.updateBuildingHandler}
										brochures={this.state.brochures}
										brochureType={this.props.brochureType}
										baseUrl={this.props.baseUrl}
										createBrochureHandler={async cb => {
											const result = await this.createBrochureHandler(building);
											if (typeof cb === 'function') {
												cb(result);
											}
										}}
										deleteBrochureHandler={this.deleteBrochureHandler}
										cloneBrochureHandler={async (cb, id) => {
											const result = await this.cloneBrochureHandler(id);
											if (typeof cb === 'function') {
												cb(result);
											}
										}}
										changeBrochureTypeHandler={this.props.changeBrochureTypeHandler}
									/>

									{
										this.state.viewImages &&
										<Modal
											header={t('building/images/modal/title')}
											body={<BuildingImages images={[...building.images]} />}
											footer={<GhostButton onClick={this.viewImagesToggleHandler}>{t('building/images/modal/close')}</GhostButton>}
										/>
									}

									{
										this.state.cloneBrochure &&
										<Modal
											header={t('building/brochures/clone/title')}
											body={(
												<CloneBrochure
													createClone={this.state.createClone}
													addBrochureClone={this.addBrochureClone}
													setCanCloneBrochure={this.setCanCloneBrochure.bind(this)}
													allowedBrochureTypes={user.can.create.master() ? ['normal', 'default'] : ['normal']}
													allowedBrochureSpaces={allowedBrochureSpaces}
													building={building}
													brochure={this.state.cloneBrochure}
												/>
											)}
											footer={
												<React.Fragment>
													<GhostButton
														onClick={() => this.setState({ cloneBrochure: false, createClone: false })}
													>
														{t('building/images/modal/close')}
													</GhostButton>
													<BigBlueButton
														onClick={() => this.setState({ createClone: true })}
														disabled={this.state.createClone || !this.state.canCloneBrochure}
													>
														{t('building/brochures/clone/title')}
													</BigBlueButton>
												</React.Fragment>
											}
										/>
									}
								</React.Fragment>
							)}
						}
					</BuildingsContext.Consumer>
				)}
			</UserContext.Consumer>
		)
	}
}

Building.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	match: PropTypes.object,
	baseUrl: PropTypes.string,
	brochures: PropTypes.array,
	brochureType: PropTypes.string,
	building: PropTypes.object,
	updateBuildingHandler: PropTypes.func,
	changeBrochureTypeHandler: PropTypes.func,
}

export default translate('translations')(Building);
